"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../styles/index.js");
var _Body = require("./Body.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Dialog = exports.Dialog = _styledComponents["default"].div.attrs({
  role: 'dialog'
}).withConfig({
  displayName: "Dialog",
  componentId: "sc-1o778i8-0"
})(["", ";width:600px;overflow-wrap:break-word;", ":first-child{padding-block-start:", ";}@media (min-width:", "){", ":last-child{padding-block-end:", ";}}"], function (props) {
  return (0, _index.dialog)({
    colorSet: props.$colorSet
  });
}, _Body.Body, (0, _index.cssSpacing)('base', '16px'), _encoreFoundation.screenSmMin, _Body.Body, (0, _index.cssSpacing)('base', '16px'));